import React, { FC } from 'react';
import AuditLogsListPage from './audit-logs-list';
import { Route, Routes } from 'react-router-dom';

const AuditLogsIndex: FC = () => {
  return (
    <Routes>
      <Route path={`/*`} element={<AuditLogsListPage />} />
    </Routes>
  );
};

export default AuditLogsIndex;
